var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"},style:({ height: _vm.height }),attrs:{"id":"mapa-leaflet"}},[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.visibilityChanged),expression:"visibilityChanged"}],style:({ height: _vm.height }),attrs:{"id":_vm.idMapa}})])
}
var staticRenderFns = []

export { render, staticRenderFns }